export default "__VITE_ASSET__c398dab7__"